import React from 'react';
import Cross from '@atlaskit/icon/glyph/cross';
import Button from '@atlaskit/button';
import { CompanyName } from './common';
// @ts-ignore
import GoalLogo from '../assets/goal-icon-on-track.svg';
import { CartCustomerSearchItem } from '../types';
import './customer-selected.scss';

interface Props {
  onCancelClick: () => void;
  customer: CartCustomerSearchItem;
}

export const CustomerSelected = ({ onCancelClick, customer }: Props) => {
  return (
    <div className="cart-customer-selected">
      <CompanyName className="mb-16" />
      <div className="flex justify-space-between ph-8 pv-16 cart-customer">
        <div className="flex align-center">
          {/* @ts-ignore */}
          <img src={GoalLogo} height="32" width="32" alt="goal icon" />
          <div className="ml-8" data-testid="selected-customer-name">
            {customer.name}
          </div>
        </div>
        <Button iconBefore={<Cross label="cancel" />} onClick={onCancelClick} />
      </div>
    </div>
  );
};
